import { render, staticRenderFns } from "./myMessageNotice.vue?vue&type=template&id=f7748644&scoped=true"
import script from "./myMessageNotice.vue?vue&type=script&lang=ts"
export * from "./myMessageNotice.vue?vue&type=script&lang=ts"
import style0 from "./myMessageNotice.vue?vue&type=style&index=0&id=f7748644&prod&lang=scss&scoped=true"
import style1 from "./myMessageNotice.vue?vue&type=style&index=1&id=f7748644&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7748644",
  null
  
)

export default component.exports